import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {LegendConfiguration} from "./legend-configuration";
import {LayerListConfiguration} from "../core/config/layer-list-configuration";
import {PrintConfiguration} from "../core/config/print-configuration";
import {ViewManagerConfiguration} from "../core/config/view-manager-configuration";

export interface SidebarControlsConfiguration {
    legend: LegendConfiguration;
    layerList: LayerListConfiguration;
    breakpoints: { [key: string]: number; };
    print: PrintConfiguration;
    viewManager?: ViewManagerConfiguration;
}

@JsonObject()
export class SidebarConfiguration {
    /**
     * Visibility of siedbar
     */
    @JsonProperty()
    declare collapsed: boolean;

    /**
     * Initial width of popup window
     */
    @JsonProperty()
    declare width: number;

    /**
     * The active accordion tab (index)
     *
     * @default ["toc"]
     */
    @JsonProperty()
    declare activeIndex: string[];

    /**
     * Exclusive panels open exclusively, all other panels are closed
     */
    @JsonProperty()
    declare exclusivePanels: string[];

    /**
     * Index of disabled panels, which are not displayed.
     */
    @JsonProperty()
    declare disabledPanels: string[];

    /**
     * Object containing semantic-ui-react icon names to get by key.
     * Use station parameter name as key
     */
    @JsonProperty()
    declare icons: { [stationParameterName: string]: string };

    constructor() {}
}
